export const GO_TO_HOME_PAGE = 'Go To Home Page';
export const PAGE_NOT_FOUND_CONTENT = "We're sorry, but the page you are looking for cannot be found.";
